export default __webpack_public_path__ + "static/media/myclassic5.1812512d.png";